import { useTranslation } from 'react-i18next'
import './index.less'
export default function PageHead({ title, desc, children, className }: any) {
  const arr = ['zh-cn', 'zh-hk', 'zh']
  const { i18n } = useTranslation()
  const w = !arr.includes(i18n.language) ? 'w' : ''
  return (<div className="page-head">
    <h1 className={ desc ? '' : 'mb0' }>{ title }</h1>
    {
      desc && <p className={'desc ' + (className || '') + ' '  + i18n.language + ' ' + w}>{ desc }</p>
    }
    {
      children && children
    }
  </div>)
}